import { BrowserRouter } from 'react-router-dom';

import { ApiRegistryProvider } from './api/provider-context';
import type { ApiRegistry } from './api/provider';
import { SessionProvider } from './api/session-provider';
import type { UnauthorizedBridge } from './api/session';
import AppErrorBoundary from './components/feature/AppErrorBoundary';
import RouteAccessibility from './components/feature/RouteAccessibility';
import { AppRoutes } from './router';

interface AppProps {
  readonly registry: ApiRegistry;
  readonly unauthorizedBridge: UnauthorizedBridge;
}

function App({ registry, unauthorizedBridge }: AppProps) {
  return (
    <AppErrorBoundary>
      <ApiRegistryProvider registry={registry}>
        <SessionProvider unauthorizedBridge={unauthorizedBridge}>
          <BrowserRouter basename={import.meta.env.BASE_URL}>
            <RouteAccessibility />
            <AppRoutes />
          </BrowserRouter>
        </SessionProvider>
      </ApiRegistryProvider>
    </AppErrorBoundary>
  );
}

export default App;
